module.exports = __webpack_public_path__ + "img/SSLRSAT.dbaa1a8c.svg";